import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthStore } from './stores/useAuthStore';
import { LoginScreen } from './components/auth/LoginScreen';
import { AppShell } from './components/shell/AppShell';

function AuthGuard({ children }: { children: React.ReactNode }) {
  const status = useAuthStore(s => s.status);

  if (status !== 'authenticated') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export function App() {
  const restoreSession = useAuthStore(s => s.restoreSession);
  const status = useAuthStore(s => s.status);
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    restoreSession();
    // Mark booted on the next tick so the synchronous status update from
    // restoreSession is already committed before we leave the boot screen.
    // This prevents a flash of the login screen when a valid session exists.
    requestAnimationFrame(() => setBooted(true));
  }, [restoreSession]);

  if (!booted) {
    return <BootScreen />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={
          status === 'authenticated' ? <Navigate to="/" replace /> : <LoginScreen />
        } />
        <Route path="/*" element={
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        } />
      </Routes>
    </BrowserRouter>
  );
}

function BootScreen() {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'var(--color-bg-primary)',
      color: 'var(--color-text-secondary)',
      flexDirection: 'column',
      gap: '16px',
    }}>
      <img src="/logo.png" alt="Rivellum" style={{ width: 48, height: 48, opacity: 0.7 }} />
      <div style={{ fontSize: '14px' }}>Loading Rivellum Console...</div>
    </div>
  );
}
